<template>
  <div>
    <h1 class="mb-8 text-3xl font-bold">
      KRS &amp; KHS Report
    </h1>
    <div class="flex justify-between items-center mb-6">
      <inertia-link
        v-if="preqCreateKRS"
        as="button"
        class="btn-indigo"
        :href="route('mahasiswa.krs.create')">
        <span>Create</span>
        <span class="hidden md:inline">KRS</span>
      </inertia-link>
      <button
        v-else
        class="btn-indigo"
        @click.prevent="alertCreateKRS">
        <span>Create</span>
        <span class="hidden md:inline">KRS</span>
      </button>
    </div>
    <div class="overflow-x-auto bg-white rounded-md shadow">
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="font-bold text-left">
            <th class="px-4 pt-6 pb-4 text-center">
              Tahun Ajaran
            </th>
            <th class="px-4 pt-6 pb-4 text-center">
              Semester
            </th>
            <th class="px-4 pt-6 pb-4 text-center">
              SKS KRS
            </th>
            <th class="px-4 pt-6 pb-4 text-left whitespace-normal break-words">
              KRS Terverifikasi?
            </th>
            <th class="px-4 pt-6 pb-4 text-left whitespace-normal break-words">
              KHS Terverifikasi?
            </th>
            <th class="px-4 pt-6 pb-4 text-left whitespace-normal break-words">
              Persetujuan Pembayaran
            </th>
            <th class="px-4 pt-6 pb-4 text-left whitespace-normal break-words">
              Status Pembayaran
            </th>
            <th class="px-4 pt-6 pb-4 text-left whitespace-normal break-words">
              Keterangan
            </th>
            <th class="px-4" />
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="row in krs.data"
            :key="row.id"
            class="focus-within:bg-gray-100 hover:bg-gray-100">
            <td class="py-4 px-6 text-center border-t">
              <inertia-link
                class="focus:text-indigo-500"
                :href="route('mahasiswa.krs.edit', row.id)">
                {{ row.school_year }}
                <icon
                  v-if="row.deleted_at"
                  name="trash"
                  class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
              </inertia-link>
            </td>
            <td class="py-4 px-6 text-center border-t">
              <inertia-link
                class="focus:text-indigo-500"
                :href="route('mahasiswa.krs.edit', row.id)">
                {{ row.school_semester }}
              </inertia-link>
            </td>
            <td class="py-4 px-6 text-center border-t">
              <inertia-link
                class="focus:text-indigo-500"
                :href="route('mahasiswa.krs.edit', row.id)">
                {{ row.krs_sks }}
              </inertia-link>
            </td>
            <td class="py-4 px-6 text-justify border-t">
              <div
                class="mb-2 text-sm font-medium"
                :class="verifiedCss(row.krs_file_verified)">
                {{ row.krs_file_verified ? `VERIF` : "BELUM VERIF" }}
              </div>
              <div>
                <p class="my-1 text-sm">
                  - Keterangan: {{ row.krs_file_reason }}
                </p>
              </div>
            </td>
            <td class="py-4 px-6 text-justify border-t">
              <div
                class="mb-2 text-sm font-medium"
                :class="verifiedCss(row.khs_file_verified)">
                {{ row.khs_file_verified ? `VERIF` : "BELUM VERIF" }}
              </div>
              <div>
                <p class="my-1 text-sm">
                  - Keterangan: {{ row.khs_file_reason }}
                </p>
              </div>
            </td>
            <td class="py-4 px-6 text-left border-t">
              <span
                :class="getStatusClass(row.approval_status)"
                class="font-bold">{{ row.approval_status }}</span>
            </td>
            <td class="py-4 px-6 text-left border-t">
              <span class="font-bold">{{ row.payment_status }}</span>
            </td>
            <td
              class="py-4 px-6 text-left whitespace-normal break-words border-t">
              {{ row.payment_status_reason }}
            </td>
            <td class="py-4 px-4 text-center border-t">
              <inertia-link
                :href="route('mahasiswa.krs.edit', row.id)"
                as="button"
                class="btn-indigo">
                Proses KHS
              </inertia-link>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import Swal from 'sweetalert2'
import { Link } from '@inertiajs/vue2'

export default {
  metaInfo: { title: 'KRS' },
  layout: Layout,
  props: {
    krs: Object,
    canCreateKRS: Boolean,
    isInputKrsClosed: Boolean,
    isEosPaymentSuccess: Boolean,
  },
  components: {
    'inertia-link': Link,
  },
  computed: {
    preqCreateKRS () {
      return (
        this.canCreateKRS && !this.isInputKrsClosed && !this.isEosPaymentSuccess
      )
    },
  },
  methods: {
    verifiedCss (stat) {
      return stat ? 'text-green-600' : 'text-red-600'
    },
    getStatusClass (stat) {
      return stat === 'Layak Bayar'
        ? 'text-green-600'
        : stat === 'Tidak Layak Bayar'
        ? 'text-red-600'
        : ''
    },
    alertCreateKRS () {
      if (this.isInputKrsClosed)
        Swal.fire(
          'Gagal Input KRS',
          'Periode penginputan sudah di tutup.',
          'error',
        )
      else if (this.isEosPaymentSuccess)
        Swal.fire(
          'Gagal Input KRS',
          'Anda telah mendapatkan Biaya AKHIR STUDI, sehingga tidak dapat lagi mengajukan Beasiswa',
          'error',
        )
      else
        Swal.fire(
          'Gagal Input KRS',
          'Tidak dapat melakukan input KRS dan KHS. <br/>' +
            'KRS dan KHS  sudah di inputkan. <br/>' +
            'Mohon menunggu hasil verifikasi.',
          'error',
        )
    },
  },
}
</script>
